import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import Header from './components/Header';
import Footer from './components/Footer';
import AnnouncementTicker from './components/AnnouncementTicker';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Membership from './pages/Membership';
import Training from './pages/Training';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Research from './pages/Research';
import Contact from './pages/Contact';
import MemberLogin from './pages/MemberLogin';
import MemberDashboard from './pages/MemberDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Verify from './pages/Verify';

function App() {
  return (
    <Router>
      <div 
        style={{ 
          minHeight: '100vh', 
          display: 'flex', 
          flexDirection: 'column',
          background: 'transparent'
        }}
      >
        <Header />
        <AnnouncementTicker />
        
        <main style={{ 
          flex: 1,
          background: 'transparent'
        }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/training" element={<Training />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/research" element={<Research />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/verify/:membershipNumber" element={<Verify />} />
            <Route path="/member-login" element={<MemberLogin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            
            {/* FIXED: Removed /:token so useSearchParams() can read query parameters (?token=...&email=...) */}
            <Route path="/reset-password" element={<ResetPassword />} />
            
            <Route path="/member-dashboard" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;